module.exports = "<p>\r\n  feedtracking works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feedtracking/feedtracking.component.html
// module id = 1080
// module chunks = 31